import { Box, Card, Grid, Stack, TextField, Typography } from "@mui/material";

import React, { useEffect, useState } from "react";

import PrimarySmallBlueButton from "../../components/customButtons/PrimarySmallBlueButton";

import { useForm, Controller } from "react-hook-form";
import CustomSelectField from "../../components/customFields/CustomSelectField";

import CustomTextField from "../../components/customFields/CustomTextField";
import SearchButton from "../../components/customButtons/SearchButton";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InfoIcon from "@mui/icons-material/Info";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

import {
  getBranchList,
  getDeliveryModes,
  rescheduleDemo,
  searchDemo,
  searchDemoDates,
} from "../testPrepDashboard/Api/DashboardApi";
import LaptopIcon from "@mui/icons-material/Laptop";
import GlobalRadioGroup from "../../components/radioButtons/GlobalRadioGroup";
import GlobalRadioButtonWithValue from "../../components/radioButtons/GlobalRadioButtonWithValue";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Loader from "../../../SAPPages/components/Loader/Loader";
import ConfimationPopup from "../../components/customPopup/ConfimationPopup";
import ErrorPopup from "../../components/customPopup/ErrorPopup";
import ErrorDialog from "../../components/customPopup/ErrorDialog";
import { createPortal } from "react-dom";
export default function RescheduleDemoScreen({
  selectedData,
  handleClose,
  handleOpenSuccessPopup,
}) {
  const {
    control,
    handleSubmit,
    setValue,
    trigger,
    getValues,
    formState: { errors },
  } = useForm({});

  const userId = localStorage.getItem("userId");
  const [DeliveryModeList, setDeliveryModeList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [sessionLoading, setSessionLoading] = useState(false);
  const [deliveryMode, setDeliveryMode] = useState(null);
  const [deliveryModeName, setDeliveryModeName] = useState(null);
  const [branch, setBranch] = useState(selectedData?.branch_id?.id || null);
  const [demoDate, setDemoDate] = useState(null);
  const [formatedDate, setFormatedDate] = useState(null);
  const [sessionData, setSessionData] = useState({});
  const [showMessge, setShowMessgae] = useState(false);
  const [classId, setClassId] = useState(null);
  const [demoDatesData, setDemoDatesData] = useState([]);
  const [isDemoData, setIsdamoData] = useState(false);
  const [showIsdemoMessage, setShowIsdemoMessage] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedClassData, setSelectedClassData] = useState(null);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [slotLoading, setSlotLoading] = useState(false);
  // fetch delivery modes
  useEffect(() => {
    const fetdeliveryModes = async () => {
      try {
        const data = await getDeliveryModes();
        const selectedDeliveryMode = data?.find(
          (i) => i.name === selectedData?.delivery_mode
        );
        setDeliveryMode(selectedDeliveryMode?.id);
        setDeliveryModeList(data);
        setValue("delivery_mode", selectedDeliveryMode?.id || null);
      } catch (err) {
        console.error("Could not fetch delivery modes", err);
      }
    };

    fetdeliveryModes();
  }, [selectedData]);

  // find delivery mode name
  useEffect(() => {
    const deliverymodeobj = DeliveryModeList?.find(
      (i) => parseInt(i.id) === parseInt(deliveryMode)
    );
    setDeliveryModeName(deliverymodeobj?.name);
  }, [deliveryMode]);

  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const data = await getBranchList();
        setBranchList(data?.data);
      } catch (err) {
        console.error("Could not fetch branches");
      }
    };

    fetchBranch();
  }, []);

  const handleSearchDemoDates = async () => {
    setSlotLoading(true);
    try {
      const payload = {
        demo_id: selectedData?.id,
        delivery_mode: parseInt(deliveryMode),
        branch_id: branch,
        user_id: parseInt(userId),
      };

      const response = await searchDemoDates(payload);
      if (response.status === 200) {
        setDemoDatesData(response?.data);
        setIsdamoData(response?.is_data);
        setSlotLoading(false);

        if (response?.is_data === false) {
          setShowIsdemoMessage(true);
        }
      } else if ([400, 401, 500].includes(response.status)) {
        setSlotLoading(false);
        setIsdamoData(false);
        if (response?.is_data === false) {
          setShowIsdemoMessage(true);
        }
      }
    } catch (error) {
      setSlotLoading(false);
      setIsdamoData(false);
    }
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    // gives YYYY-MM-DD in IST
  };

  // Only allow dates that have slots
  const filterDate = (date) => {
    const dateStr = formatDate(date);
    const dateObj = demoDatesData.find((d) => d.date === dateStr);
    return dateObj?.is_slot === true;
  };

  // Highlight dates with available slots
  const customDayClass = (date) => {
    const dateStr = formatDate(date);
    const dateObj = demoDatesData.find((d) => d.date === dateStr);

    if (dateObj?.is_slot === true) {
      return "react-datepicker__day--highlighted-pink"; // pink
    } else {
      return "react-datepicker__day--disabled"; // disabled
    }
  };

  useEffect(() => {
    if (deliveryModeName === "online") {
      // ✅ Always fetch for online
      handleSearchDemoDates();
      setDemoDate(null);
    } else if (deliveryModeName === "offline" && branch) {
      // ✅ Only fetch for offline when branch is selected
      handleSearchDemoDates();
      setDemoDate(null);
    }
  }, [deliveryModeName, branch]);

  const searchFields = [
    "test_delivery_format_id",
    "delivery_mode",
    "branch_id",
    "available_demo_date",
  ];

  const handleSearchDemoClick = async () => {
    try {
      // ✅ only validate specific fields
      const isValid = await trigger(searchFields);
      if (!isValid) return;

      // ✅ Get current form values
      const values = getValues();

      // ✅ Call API with processed values
      await handleSearchDemo(values);
    } catch (error) {
      console.error("Error during search click:", error);
    }
  };

  useEffect(() => {
    // ✅ Convert to local date (ignore timezone shift)
    const formattedDate = demoDate
      ? new Date(demoDate).toLocaleDateString("en-CA", {
          timeZone: "Asia/Kolkata",
        }) // "YYYY-MM-DD" in IST
      : null;
    setFormatedDate(formattedDate);
  }, [demoDate]);

  const handleSearchDemo = async (formValues) => {
    try {
      setSessionLoading(true);
      setClassId(null);

      const payload = {
        ...formValues, // form values
        available_demo_date: formatedDate, // ✅ only date part
        user_id: Number(userId), // ensure it's a number
        test_type_id: selectedData?.test_type_id?.id || null,
        delivery_mode: parseInt(deliveryMode), // override with state
        branch_id: deliveryModeName === "offline" ? formValues.branch_id : null,
        same_trainer: null,
        note: null,
        sub_test_type_id: selectedData?.sub_test_type_id?.id || null,
      };

      const response = await searchDemo(payload);
      console.log("response", response);

      if (response?.status === 200) {
        const sessions = response?.data ?? [];
        setSessionData(sessions);

        // ✅ handle empty sessions case
        setShowMessgae(sessions.length === 0);
      } else {
        console.error("Search demo failed:", response);
      }
    } catch (error) {
      console.error("Error fetching demo:", error);
    } finally {
      setSessionLoading(false);
    }
  };

  const handleChangeClass = (classId, sessionData) => {
    setClassId(classId);
    setSelectedClassData(sessionData);
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  // Reschedule Demo

  const handleSubmitData = async () => {
    if (classId === null) {
      setErrorMessage(
        "You haven’t selected a class slot yet. Please choose a class slot from the list before continuing"
      );
      handleOpenErrorPopup();
      return;
    }

    try {
      const payload = {
        id: selectedData?.id,
        available_demo_date: formatedDate, // ✅ only date part
        user_id: parseInt(userId),
        class_id: parseInt(classId),
        slot: selectedClassData?.slots,
      };

      const response = await rescheduleDemo(payload);
      console.log("response", response);
      if (response.status === 200) {
        handleClose();
        handleOpenSuccessPopup();
      } else if ([400, 409, 401, 500].includes(response.status)) {
        setErrorMessage(response?.message);
        handleOpenErrorPopup();
      } else {
        setErrorMessage(response?.message);
        handleOpenErrorPopup();
      }
    } catch (error) {
      setErrorMessage("Internal Server Error");
      handleOpenErrorPopup();
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} textAlign="center">
          <Typography
            color="#A314AA"
            fontFamily="Inter"
            fontSize="24px"
            lineHeight="1.4"
            letterSpacing="0px"
            style={{ fontWeight: 500 }}
          >
            Reschedule Your Demo Class : {selectedData?.class_id?.name}
          </Typography>
        </Grid>
        <Grid item xs={12} mb={2} textAlign="center">
          <Typography
            color="#3F424C"
            fontFamily="Inter"
            fontSize="15px"
            lineHeight="100%"
            letterSpacing="0px"
            style={{ fontWeight: 400 }}
          >
            Select mode and date, for available slots.
          </Typography>
        </Grid>

        {/* <Grid item xs={12} md={6}>
          <Typography
            fontSize="14px"
            color="#572575"
            mb={1}
            sx={{
              fontWeight: 400,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0.1px",
              verticalAlign: "middle",
              lineHeight: "100%",
            }}
          >
            Test Type<span style={{ color: "red" }}>*</span>
          </Typography>
          <Controller
            name="delivery_mode"
            control={control}
            rules={{ required: "Please choose one option" }}
            render={({ field }) => (
              <CustomTextField
                {...field}
                fullWidth
                fontSize={14}
                type="text"
                borderColor="#E6E2F7"
                value={selectedData?.test_type_id?.name}
                readOnly
              />
            )}
          />
        </Grid> */}

        {/* Delivery Mode */}
        <Grid item xs={12} md={6}>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap={0.5}
            mb={1}
          >
            <Typography
              fontSize="14px"
              color="#572575"
              sx={{
                fontWeight: 400,
                fontFamily: "Inter",
                fontStyle: "normal",
                letterSpacing: "0.1px",
                verticalAlign: "middle",
                lineHeight: "100%",
              }}
            >
              Delivery Mode <span style={{ color: "red" }}>*</span>
            </Typography>
          </Box>

          <Controller
            name="delivery_mode"
            control={control}
            rules={{ required: "Please choose one option" }}
            render={({ field }) => (
              <>
                <Box
                  sx={{
                    border: "1px solid #E6E2F7",
                    borderRadius: "8px",
                    px: "10px",
                  }}
                >
                  <GlobalRadioButtonWithValue
                    {...field}
                    options={DeliveryModeList}
                    value={deliveryMode}
                    color="#9D0385"
                    getOptionLabel={(opt) =>
                      opt?.name === "offline" ? "Offline Mode" : "Online Mode"
                    }
                    getOptionValue={(opt) => opt?.id}
                    onChange={(e) => {
                      setDeliveryMode(parseInt(e.target.value, 10));
                      setValue("delivery_mode", parseInt(e.target.value));
                      setBranch(null);
                      setIsdamoData(false);
                      setSessionData([])
                    }}
                  />
                </Box>

                {/* ✅ show error below radios */}
                {errors.delivery_mode && (
                  <Typography color="error" fontSize="12px" mt={0.5}>
                    {errors.delivery_mode.message}
                  </Typography>
                )}
              </>
            )}
          />
        </Grid>

        {/* select branch */}
        {deliveryModeName === "offline" && (
          <Grid item xs={12} md={6}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap={0.5}
              mb={1}
            >
              <Typography
                fontSize="14px"
                color="#572575"
                sx={{
                  fontWeight: 400,
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  letterSpacing: "0.1px",
                  verticalAlign: "middle",
                  lineHeight: "100%",
                }}
              >
                Branch <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
            <Controller
              name="branch_id"
              control={control}
              rules={{
                required:
                  deliveryModeName === "Offline" ? "Branch is required" : false,
              }}
              defaultValue={selectedData?.branch_id?.id}
              render={({ field }) => (
                <CustomSelectField
                  {...field}
                  fullWidth
                  options={branchList}
                  value={branch}
                  borderColor="#E6E2F7"
                  fontSize={14}
                  onChange={(e) => {
                    setBranch(e.target.value);
                    setValue("branch_id", e.target.value);
                         setSessionData([])
                  }}
                  getOptionLabel={(opt) => opt?.branch_name}
                  getOptionValue={(opt) => opt?.id}
                  error={!!errors.branch_id}
                  helperText={errors.branch_id?.message}
                >
                  {" "}
                </CustomSelectField>
              )}
            />
          </Grid>
        )}

        {/* Demo Date */}
        {isDemoData && (
          <Grid item xs={12} md={6}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap={0.5}
              mb={1}
            >
              <Typography
                fontSize="14px"
                color="#572575"
                sx={{
                  fontWeight: 400,
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  letterSpacing: "0.1px",
                  verticalAlign: "middle",
                  lineHeight: "100%",
                }}
              >
                Demo Date <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>

            <Controller
              name="available_demo_date"
              control={control}
              rules={{ required: "Demo date is required" }}
              render={({ field }) => (
                <DatePicker
                  fullWidth
                  {...field}
                  selected={demoDate}
                  onChange={(date) => {
                    setDemoDate(date);
                    field.onChange(date); // important for react-hook-form
                  }}
                  filterDate={filterDate}
                  dayClassName={customDayClass}
                  dateFormat="dd - MM - yyyy"
                  customInput={
                    <CustomTextField
                      fullWidth
                      variant="outlined"
                      borderColor="#E6E2F7"
                      size="small"
                      color="#9D0385"
                      fontWeight={700}
                      fontSize={13}
                      error={!!errors.available_demo_date}
                      helperText={errors.available_demo_date?.message}
                      InputProps={{
                        endAdornment: (
                          <CalendarTodayIcon
                            style={{ cursor: "pointer", fontSize: "1rem" }}
                          />
                        ),
                      }}
                    />
                  }
                />
              )}
            />
          </Grid>
        )}

        {slotLoading && (
          <Grid item xs={12} textAlign="center">
            <Loader text="Loading Demo Slots ..." height="20vh" />
          </Grid>
        )}

        {!slotLoading && !isDemoData && showIsdemoMessage && (
          <Grid item xs={12} textAlign="center">
            <Box
              sx={{
                background: "#BA15150F",
                padding: "10px",
                borderRadius: "8px",
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap={1}
            >
              <InfoIcon style={{ color: "#BA1515" }} />
              <Typography
                fontSize="12px"
                color="#BA1515"
                sx={{
                  fontWeight: 400,
                  fontFamily: "Inter",
                  lineHeight: "100%",
                  fontStyle: "normal",
                  letterSpacing: "0%",
                }}
              >
                No slots available for the selected criteria in the next 10
                days.
              </Typography>
            </Box>
          </Grid>
        )}
        <Grid item xs={12} textAlign="center" mt={1}>
          <SearchButton text="Find the Slots" onClick={handleSearchDemoClick} />
        </Grid>

        {sessionLoading && (
          <Grid item xs={12} textAlign="center">
            <Loader text="Loading Demo Sessions ..." height="20vh" />
          </Grid>
        )}

        {!sessionLoading && showMessge && (
          <Grid item xs={12} textAlign="center">
            <Box
              sx={{
                background: "#BA15150F",
                padding: "10px",
                borderRadius: "8px",
              }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap={1}
            >
              <InfoIcon style={{ color: "#BA1515" }} />
              <Typography
                fontSize="12px"
                color="#BA1515"
                sx={{
                  fontWeight: 400,
                  fontFamily: "Inter",
                  lineHeight: "100%",
                  fontStyle: "normal",
                  letterSpacing: "0%",
                }}
              >
                No slots Found here for the Selected Criteria
              </Typography>
            </Box>
          </Grid>
        )}

        {!sessionLoading && sessionData?.length > 0 && (
          <Grid item xs={12}>
            <Box
              sx={{
                borderRadius: 3,
                border: "1px solid #EEEEEE",
                p: 2,
                mt: 1,
              }}
            >
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1}
                mb={1}
              >
                <EventAvailableIcon style={{ color: "#A314AA" }} />
                <Typography
                  fontSize="18px"
                  color="#A314AA"
                  mb={1}
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    letterSpacing: "0.1px",
                    verticalAlign: "middle",
                    lineHeight: "100%",
                  }}
                >
                  Available Demo Sessions for {formatedDate}
                </Typography>
              </Stack>

              <Typography
                textAlign="center"
                fontSize="14px"
                color="#444444"
                mb={1}
                sx={{
                  fontWeight: 400,
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  letterSpacing: "0.1px",
                  verticalAlign: "middle",
                  lineHeight: "100%",
                }}
              >
                We have several slots available on this date. Select a time that
                works best for you.
              </Typography>

              <Grid container spacing={3} mt={2}>
                {sessionData?.map((session, index) => (
                  <Grid item xs={12} md={4} key={index}>
                    <Card
                      onClick={() =>
                        handleChangeClass(session?.class_id, session)
                      }
                      sx={{
                        border: "1px solid #eee",
                        borderRadius: 2,
                        boxShadow: classId === session?.class_id ? 4 : 1,
                        backgroundColor:
                          classId === session?.class_id ? "#FAF5FF" : "#fff",
                        transition: "0.3s",
                        height: "100%",
                        padding: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <Stack spacing={2}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Box width={32}>
                            <img src="/newdashboard/Demo/Group 1171283449.png" />
                          </Box>
                          <Typography
                            textAlign="center"
                            fontSize="13px"
                            color="#000000"
                            mb={1}
                            sx={{
                              fontWeight: 400,
                              fontFamily: "Inter",
                              fontStyle: "normal",
                              letterSpacing: "0.1px",
                              verticalAlign: "middle",
                              lineHeight: "100%",
                            }}
                          >
                            {session.slots}
                          </Typography>
                        </Stack>

                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Box width={32}>
                            <img src="/newdashboard/Demo/Group 1171283449 (1).png" />
                          </Box>
                          <Typography
                            textAlign="center"
                            fontSize="13px"
                            color="#000000"
                            mb={1}
                            sx={{
                              fontWeight: 500,
                              fontFamily: "Inter",
                              fontStyle: "normal",
                              letterSpacing: "0.1px",
                              verticalAlign: "middle",
                              lineHeight: "100%",
                            }}
                          >
                            <span
                              style={{
                                color: "#A314AA",
                                fontWeight: 600,
                              }}
                            >
                              {" "}
                              {session?.available_slot}
                            </span>{" "}
                            seats available
                          </Typography>
                        </Stack>
                        {/* {session?.branch && (
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <Box width={32}>
                                <img src="/newdashboard/Demo/Group 1171283449 (2).png" />
                              </Box>
                              <Typography
                                textAlign="center"
                                fontSize="13px"
                                color="#000000"
                                mb={1}
                                sx={{
                                  fontWeight: 400,
                                  fontFamily: "Inter",
                                  fontStyle: "normal",
                                  letterSpacing: "0.1px",
                                  verticalAlign: "middle",
                                  lineHeight: "100%",
                                }}
                              >
                                {session.branch}
                              </Typography>
                            </Stack>
                          )} */}
                      </Stack>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        )}

        {sessionData?.length > 0 && (
          <Grid item xs={12} textAlign="center" mt={1}>
            <PrimarySmallBlueButton
              buttonTitle="Reschedule to This Slot"
              width="60%"
              startIcon={<LaptopIcon />}
              onClick={handleSubmitData}
            />
          </Grid>
        )}
      </Grid>

      <style>{`
      .react-datepicker-wrapper {
  width: 100% !important;
}
  /* Main calendar */
.react-datepicker {
  border: none !important;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  font-family: "Inter", sans-serif;
  padding: 8px;
}
  /* Header */
.react-datepicker__header {
  background: #fff;
  border-bottom: none;
  padding-top: 10px;
}
  .react-datepicker__current-month {
  font-size: 12px;
  font-weight: 700;
  color: #572575;
}

.react-datepicker__day-name {
  font-size: 14px;
  color: #A314AA;
  font-weight: 500;
  width: 36px;
  text-transform: none;
}

/* Replace default short names with custom ones */
.react-datepicker__day-name:nth-child(1)::after { content: "Sun"; }
.react-datepicker__day-name:nth-child(2)::after { content: "Mon"; }
.react-datepicker__day-name:nth-child(3)::after { content: "Tue"; }
.react-datepicker__day-name:nth-child(4)::after { content: "Wed"; }
.react-datepicker__day-name:nth-child(5)::after { content: "Thu"; }
.react-datepicker__day-name:nth-child(6)::after { content: "Fri"; }
.react-datepicker__day-name:nth-child(7)::after { content: "Sat"; }

/* Hide the original text (Su, Mo…) */
.react-datepicker__day-name {
  font-size: 0 !important;
}
.react-datepicker__day-name::after {
  font-size: 12px !important;
}



  /* Days */
/* Add spacing between day cells */
.react-datepicker__day {
  margin: 3px 6px; /* Horizontal margin */  /* adjust for more/less space */
 
 font-size: 12px !important;
  border-radius: 8px; /* keep rounded look */
  display: inline-flex;
  align-items: center;
  justify-content:center;
}

       .react-datepicker__day--highlighted-pink {
  background: linear-gradient(135deg, #9C48F0, #A314AA) !important;
  color: #fff !important;
  border-radius: 6px !important;


  
}


        .react-datepicker__day--disabled {
          color: #ccc;
          pointer-events: none;
        }
          /* Keep same pink on hover */
.react-datepicker__day--highlighted-pink:hover {
    background: linear-gradient(135deg, #9C48F0, #A314AA) !important;
  color: #fff !important;
}




.react-datepicker__navigation {
  top: 12px;
  width: 25px; /* Button size */
  height: 25px; /* Button size */
  border-radius: 50%;
  background: #9D03850D; /* light pink background */
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;
  outline: none !important;
  transition: all 0.2s ease;
  margin: 0px 12px; /* Horizontal margin */
}



/* Common styles for all navigation icons */
.react-datepicker__navigation-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  position: relative;
  top:2 !important
}

/* Adjust position of right (next) icon */
.react-datepicker__navigation--next .react-datepicker__navigation-icon {
  position: relative;
  left: 0px;  /* Or any value you want */
  top: 0px;   /* Or any value you want */
}

/* Adjust position of left (previous) icon if needed */
.react-datepicker__navigation--previous .react-datepicker__navigation-icon {
  position: relative;
  left: 0px;
  top: 4px;
}


/* Reset default before pseudo element */
.react-datepicker__navigation-icon::before {
  content: '';
  position: absolute;
  border-style: solid;
  border-width: 2px 2px 0 0;
  width: 7px;
  height: 7px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Left arrow (Previous month) */
.react-datepicker__navigation--previous .react-datepicker__navigation-icon::before {
  border-color: #A314AA;
  transform: translate(-50%, -50%) rotate(-135deg);
  top:2px
}

/* Right arrow (Next month) */
.react-datepicker__navigation--next .react-datepicker__navigation-icon::before {
  border-color: #A314AA;
  transform: translate(-50%, -50%) rotate(45deg);
}

// /* Hover effect – white arrows */
// .react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
//   border-color: #fff;
// }

      `}</style>

      <ConfimationPopup
        handleClose={handleCloseErrorPopup}
        component={
          <ErrorPopup
            handleClose={handleCloseErrorPopup}
            const
            text=""
            subText={errorMessage}
            buttonTitle="Continue"
            // startIcon={<ArticleIcon />}
            navigateLink="/test-prep/demos"
          />
        }
        open={openErrorPopup}
        subtitle=""
        maxWidth="xs"
      />
    </>
  );
}
